import { RouteRecordRaw } from 'vue-router';

export const accessibilityRoute: RouteRecordRaw = {
  name: 'AccessibilityView',
  path: '/accessibility',
  component: () => import('@/modules/Accessibility/AccessibilityStatement.vue'),
};
